<template>
    <div class="tds-error fade-in mb-4">
        <h5 v-if="title">{{ title }}</h5>
        <p v-html="message"></p>
    </div>
</template>

<script lang="ts">

import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class TDSError extends Vue {
    @Prop({type: String, default: ""}) title?: string;
    @Prop({type: String, default: ""}) message?: string;
}
</script>


<style lang="scss" scoped>
    .tds-error {
        background-image: url("../../assets/icons/warning2-dent-red.svg");
        background-repeat: no-repeat;
        padding-left: 32px;
        background-position: 0 1px;
        h5 {
            color: $fullGrey;
            font-size: 16px;
            font-weight: 600;
            line-height: 18px;
            margin: 0 0 8px 0;
        }
        p {
            color: $tendencyRed;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: -0.22px;
            line-height: 18px;
        }
    }
</style>
